import { render, staticRenderFns } from "./StakingViewProgramsGeneral.vue?vue&type=template&id=7c86633b&lang=pug"
import script from "./StakingViewProgramsGeneral.vue?vue&type=script&lang=ts"
export * from "./StakingViewProgramsGeneral.vue?vue&type=script&lang=ts"
import style0 from "./StakingViewProgramsGeneral.vue?vue&type=style&index=0&id=7c86633b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSwitch,VTooltip})
